import BaseRepository from '@/api/repositories/BaseRepository';

class CustomerPermissionsRepository extends BaseRepository {
	get endpoint() {
		return 'api/customer-permissions';
	}

	updatePermissions(permissionId, data) {
		return this.put(`${permissionId}/change`, {}, data);
	}
}

export default new CustomerPermissionsRepository();
